import {
  AnonymousRoute,
  AuthenticatedRoute,
} from "@sharpana/auth/AuthRoutingWrappers";

import Login from "@sharpana/auth/flows/Login";
import Logout from "@sharpana/auth/flows/Logout";
import Signup from "@sharpana/auth/flows/Signup";
import LoginWebExtensionProviderPopup from "@sharpana/auth/flows/LoginWebExtensionProviderPopup";

import ProviderSignup from "@sharpana/auth/social_account_providers/ProviderSignup";
import ProviderCallback from "@sharpana/auth/social_account_providers/ProviderCallback";

import RequestPasswordReset from "@sharpana/auth/flows/RequestPasswordReset";
import ChangePassword from "@sharpana/auth/flows/ChangePassword";
import ResetPassword, {
  loader as resetPasswordLoader,
} from "@sharpana/auth/flows/ResetPassword";

import ChangeEmail from "@sharpana/auth/flows/ChangeEmail";
import VerifyEmail, {
  loader as verifyEmailLoader,
} from "@sharpana/auth/flows/VerifyEmail";
import VerifyEmailByCode from "@sharpana/auth/flows/VerifyEmailByCode";
import VerificationEmailSent from "@sharpana/auth/flows/VerificationEmailSent";

export function getAuthRoutes(config) {
  return [
    {
      path: "/account/email",
      element: (
        <AuthenticatedRoute>
          <ChangeEmail />
        </AuthenticatedRoute>
      ),
    },
    {
      path: "/account/login",
      element: (
        <AnonymousRoute>
          <Login />
        </AnonymousRoute>
      ),
    },
    {
      path: "/account/logout",
      element: <Logout />,
    },
    {
      path: "/account/login-web-extension/provider/popup/:providerId",
      element: (
        <AnonymousRoute>
          <LoginWebExtensionProviderPopup />
        </AnonymousRoute>
      ),
    },
    {
      path: "/account/provider/callback/:mode?",
      element: <ProviderCallback />,
    },
    {
      path: "/account/provider/signup",
      element: (
        <AnonymousRoute>
          <ProviderSignup />
        </AnonymousRoute>
      ),
    },
    {
      path: "/account/signup",
      element: (
        <AnonymousRoute>
          <Signup />
        </AnonymousRoute>
      ),
    },
    {
      path: "/account/verify-email",
      element: config.data.account.email_verification_by_code_enabled ? (
        <VerifyEmailByCode />
      ) : (
        <VerificationEmailSent />
      ),
    },
    {
      path: "/account/verify-email/:key",
      element: <VerifyEmail />,
      loader: verifyEmailLoader,
    },
    {
      path: "/account/password/reset",
      element: (
        <AnonymousRoute>
          <RequestPasswordReset />
        </AnonymousRoute>
      ),
    },
    {
      path: "/account/password/reset/key/:key",
      element: (
        <AnonymousRoute>
          <ResetPassword />
        </AnonymousRoute>
      ),
      loader: resetPasswordLoader,
    },
    {
      path: "/account/password/change",
      element: (
        <AuthenticatedRoute>
          <ChangePassword />
        </AuthenticatedRoute>
      ),
    },
  ];
}
